// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const stnr: CountryValidator<"DE"> = createValidator(
  "de.stnr",
  53,
);

export default stnr;
export const compact = stnr.compact;
export const format = stnr.format;
export const validate = stnr.validate;
export const generate = (): string =>
  stnr.generate?.() ??
  (() => {
    throw new Error(
      "Validator de.stnr cannot generate values",
    );
  })();
